import { render, staticRenderFns } from "./newScriptManagementTwo.vue?vue&type=template&id=4e9eb0b2&scoped=true"
import script from "./newScriptManagementTwo.vue?vue&type=script&lang=js"
export * from "./newScriptManagementTwo.vue?vue&type=script&lang=js"
import style0 from "./newScriptManagementTwo.vue?vue&type=style&index=0&id=4e9eb0b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9eb0b2",
  null
  
)

export default component.exports